import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row flex-nowrap w-full" }
const _hoisted_2 = { class: "flex-1 pr-30" }
const _hoisted_3 = { class: "min-w-120 u-valign-inline-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ConfirmationButton = _resolveComponent("ConfirmationButton")!
  const _component_WebApiMessage = _resolveComponent("WebApiMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_Form, {
      "validation-schema": _ctx.formValidation,
      onSubmit: _ctx.submit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_InputText, {
              name: "id",
              label: _ctx.labels.offerNumberInputPlaceholder
            }, null, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ConfirmationButton, {
              class: "w-full",
              confirm: _ctx.pending,
              text: _ctx.labels.findOfferButtonText,
              "confirmation-text": _ctx.labels.findOfferButtonPendingText
            }, null, 8, ["confirm", "text", "confirmation-text"])
          ])
        ]),
        _createVNode(_component_WebApiMessage, {
          id: _ctx.findPersonalOfferWebApiMessageKey,
          "clear-timing": 3000,
          class: "absolute -mt-40"
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["validation-schema", "onSubmit"])
  ]))
}